import { useMutation } from '@tanstack/react-query';

type JobSourceReloadPostRequest = {
  id: number;
};

export default function usePostJobSourceReload() {
  const token = (document.getElementsByName('csrf-token')[0] as HTMLMetaElement).content;

  return useMutation({
    mutationFn: async ({ id }: JobSourceReloadPostRequest): Promise<void> => {
      const response = await fetch(`/agent/api/job_sources/${id}/reload`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'X-CSRF-Token': token,
        },
      });

      const data = await response.json();
      return data;
    },
  });
}
